import { Record } from 'immutable';
import { cleanString } from '../utilities';

export default class MemberExtendedRecord extends Record({
  photo: '',
  website: '',
  content: '',
  lang: '',
  firmPrefEmailAddress: ''
}) {
  constructor(data = {}) {
    data.content = cleanString(data.content);
    data.website = cleanString(data.website);

    super(data);
  }
}



// WEBPACK FOOTER //
// ./src/records/MemberExtended.js